module.exports = __webpack_public_path__ + "img/wenhao.233a54e4.svg";